exports.BASE_URL = 'https://application.myinfomart.in/api';  
exports.BASE_FILE_URL = 'https://application.myinfomart.in/';          
exports.BASE_PAYMENT_URL = 'https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction';